import { render, staticRenderFns } from "./StudyConversationMessageEditorText.vue?vue&type=template&id=d2eca422&scoped=true"
import script from "./StudyConversationMessageEditorText.vue?vue&type=script&lang=js"
export * from "./StudyConversationMessageEditorText.vue?vue&type=script&lang=js"
import style0 from "./StudyConversationMessageEditorText.vue?vue&type=style&index=0&id=d2eca422&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2eca422",
  null
  
)

export default component.exports